@if(isAvailable){
<app-toggle [ngModel]="isActive" (ngModelChange)="toggleWakelock($event)">{{'common.keep_screen_on'|translate}}</app-toggle>
}